import { AllKeys } from 'pages/claims/components';

/******* Info Section **********/
export const baseInfoSectionKeys: AllKeys[] = [
  'serviceStart',
  'serviceEnd',
  'payorID',
  'intakeItemID',
];
export const editInfoSectionKeys: AllKeys[] = [
  ...baseInfoSectionKeys,
  'version',
  'claimNumber',
  'messageID',
];

export const createInfoSectionKeys: AllKeys[] = [...baseInfoSectionKeys];

export const bulkInfoSectionKeys: AllKeys[] = [...createInfoSectionKeys];

export const baseNotesSectionKeys: AllKeys[] = [
  'providerNotes',
  'providerComments',
  'clerkComments',
  'internalComments',
];
export const claimCommentSectionKeys: AllKeys[] = ['internalComments'];
/******* Detail Section **********/
export const baseDetailSectionKeys: AllKeys[] = [
  'locationOfService',
  'serviceLocationIndicator',
  'hospitalCode',
];

export const SKClaimDetailSectionKeys: AllKeys[] = [
  'claimType',
  'claimMode',
  'formType',
  'corporationIndicator',
  'specialCircumstances',
];

export const baseAdditionalInfoSectionKeys: AllKeys[] = [
  'patientCount',
  'virtualPhysicianRegion',
  'thirdPartyLiability',
  'optometristReason',
  'incorporated',
  'interpretingRadiologist',
  'chiroService',
];

/******* Site Section **********/
export const siteSectionKeys: AllKeys[] = ['facilityNumber'];

export const createDetailSectionKeys: AllKeys[] = [
  ...baseDetailSectionKeys,
  ...baseAdditionalInfoSectionKeys,
  ...baseNotesSectionKeys,
  ...siteSectionKeys,
];
export const bulkDetailSectionKeys: AllKeys[] = [
  'serviceStart',
  'payorID',
  ...baseDetailSectionKeys,
  ...baseNotesSectionKeys.filter((key) => key !== 'internalComments'),
  ...siteSectionKeys,
];
export const bulkSharedDetailSectionKeys: AllKeys[] = [
  ...bulkDetailSectionKeys,
  'intakeItemID',
];
export const individualDetailSectionKeys: AllKeys[] = [
  ...bulkDetailSectionKeys,
  ...baseAdditionalInfoSectionKeys,
];

export const editDetailSectionKeys: AllKeys[] = [
  ...baseDetailSectionKeys,
  ...baseAdditionalInfoSectionKeys,
  ...baseNotesSectionKeys,
  ...siteSectionKeys,
];

/******* Provider Section **********/
export const providerSectionKeys: AllKeys[] = [
  'provider.firstName',
  'provider.lastName',
  'provider.specialtyCode',
  'provider.licenses',
  'provider.contactNote',
  'groupID',
];

/******* Patient Section **********/
export const patientSectionKeys: AllKeys[] = [
  'patient.lastName',
  'patient.firstName',
  'patient.dateOfBirth',
  'patient.address',
  'patient.city',
  'patient.province',
  'patient.country',
  'patient.postalCode',
  'patient.phone',
  'patient.sex',
  'patient.organizationID',
];

/******* Healthcard Section **********/
export const healthcardSectionKeys: AllKeys[] = [
  'healthcard.number',
  'healthcard.registration',
  'healthcard.province',
];

/******* Tariff Section **********/
export const tariffSectionKeys: AllKeys[] = [
  'tariffs.icd9',
  'referringProvider',
  'tariffs',
];

/******* Additional Sections **********/
export const eobSectionKeys: AllKeys[] = ['debits.eobs'];
export const debitSectionKeys: AllKeys[] = [
  'debits.requestedAmount',
  'credit.amount',
];
